module.exports = __webpack_public_path__ + "graphics/06.ckh.5789e4029cc54d13c65b3ce6628e8a28.png";